import { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "How does the AI predict match outcomes?",
    answer:
      "Our AI analyzes team performance, player stats, and historical data to generate predictions.",
  },
  {
    question: "How accurate are the predictions?",
    answer:
      "While we strive for high accuracy, predictions are based on probabilities and real-world factors can impact outcomes.",
  },
  {
    question: "Can the predictions be used for betting?",
    answer:
      "Our AI-generated predictions, based on machine learning models and statistical probabilities, can be used for betting. Please gamble responsibly.",
  },
  {
    question: "How often are the predictions updated?",
    answer:
      "Predictions are updated regularly based on the latest match data and player performances.",
  },
  {
    question: "Is the app free to use?",
    answer:
    "Yes, the app is free to use but with very limited features on the free plan. Subscribe to unlock premium insights.",
  },
  {
    question: "What does NED mean?",
    answer:
      "NED means Not Enough Data. It is a prediction status that indicates insufficient data to generate a confident prediction.",
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-lg mx-auto p-6 w-full text-left relative bottom-16 md:bottom-0">
      <h2 className="text-3xl font-bold text-center mb-6">Frequently Asked Questions</h2>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="border-b border-gray-200 pb-4">
            <button
              className="flex items-center justify-start w-full text-lg font-medium text-gray-700 py-3"
              onClick={() => toggleFAQ(index)}
              aria-expanded={openIndex === index}
              aria-controls={`faq-body-${index}`}
            >
              <span className="flex-1 text-left">{faq.question}</span>
              <ChevronDown
                className={`w-5 h-5 transition-transform ${openIndex === index ? "rotate-180" : ""}`}
              />
            </button>
            <div
              id={`faq-body-${index}`}
              className={`overflow-hidden transition-all ${openIndex === index ? "max-h-40" : "max-h-0"}`}
            >
              <p className="text-gray-500 text-sm mt-2">{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
